import { z } from "zod"
import { formDirtySchema } from "@/modules/patients/detail/progress-note/components/progress-note-editable/treatment-plan-section"
import { SpecialtyType } from "@/modules/patients/detail/progress-note/components/specialty-select"
import { PURPOSE_POINT_OF_CARE_ITEMS } from "@/modules/patients/detail/progress-note/point-of-care/constants"
import {
  BetterDocResultStatusValues,
  PointOfCareType,
  PointOfCareTypeValues,
  ReasonForChoosingTypeValues,
  ResolvedBetterDocUsageValues,
  TimeToTreatTypeValues,
} from "@/types/__generated__/union-types"

export const BASE_NO_SPECIALTY: PointOfCareType[] = [
  "GENERAL_PRACTITIONER",
  "HOSPITAL_EMERGENCY_ROOM",
  "EMERGENCY_CALL",
  "INCOMPLETE_TELECONSULTATION",
  "TELECARE",
  "MEDICAL_EMERGENCY_OR_PERMANENCE",
]

export const BASE_NO_TIME_TO_TREAT: PointOfCareType[] = ["INCOMPLETE_TELECONSULTATION", "EMERGENCY_CALL", "TELECARE"]

export const PURPOSE_VALUES = PURPOSE_POINT_OF_CARE_ITEMS.map((item) => item.value)

const isSpecialty = (value: unknown): value is SpecialtyType =>
  typeof value === "object" && value !== null && "id" in value && "word" in value

export const baseSchema = z
  .object({
    specialtyId: z.custom<SpecialtyType>().refine(isSpecialty).optional().nullable(),
    careProviderId: z.string().optional().nullable(),
    timeToTreatType: z.enum(TimeToTreatTypeValues).optional().nullable(),
    isDoctorVisitAvoided: z.boolean().optional().nullable(),
    isBetterDocSuggestion: z.boolean().optional(),
    resolvedBetterDocUsage: z.enum(ResolvedBetterDocUsageValues).optional().nullable(),
    purpose: z.array(z.enum(PURPOSE_VALUES)).optional(),
    reasonForChoosingType: z.enum(ReasonForChoosingTypeValues).optional().nullable(),
    medicalPointOfCare: z.enum(PointOfCareTypeValues, { error: "common.fieldErrorList.requiredField" }),
    actualPointOfCare: z.enum(PointOfCareTypeValues).optional().nullable(),
    betterDocSuggestionStatus: z.enum(BetterDocResultStatusValues).optional().nullable(),
  })
  .extend(formDirtySchema.shape)
